import styled from 'styled-components';

import { Tooltip } from '@dreryk/react-components';

export const StyledEwusPatientDownloadTooltip = styled(Tooltip)`
   margin-top: 26px;
`;
